import isEqual from "fast-deep-equal"

import type { MetricRecordData } from "@/types/metrics/contracts"

function mergeLocalChanges<T extends object>(
  previous: T,
  local: T,
  refreshed: T,
): T {
  const merged = { ...refreshed }
  const keys = new Set<keyof T>([
    ...(Object.keys(previous) as Array<keyof T>),
    ...(Object.keys(local) as Array<keyof T>),
    ...(Object.keys(refreshed) as Array<keyof T>),
  ])

  for (const key of keys) {
    if (!isEqual(local[key], previous[key])) {
      merged[key] = local[key]
    }
  }

  return merged
}

/**
 * Applies an external metric refresh without reintroducing stale untouched
 * fields into a later full-record save. Metadata is merged at its own field
 * boundary because the editor replaces the metadata object as a whole.
 */
export function mergeRefreshedMetric(
  previous: MetricRecordData,
  local: MetricRecordData,
  refreshed: MetricRecordData,
): MetricRecordData {
  return {
    ...mergeLocalChanges(previous, local, refreshed),
    metric_metadata: mergeLocalChanges(
      previous.metric_metadata,
      local.metric_metadata,
      refreshed.metric_metadata,
    ),
  }
}
